import { useState } from 'react';
import { saveUserAvatar, loadUserAvatars, type UserAvatarSave } from '../services/avatarSaveService';
import { useAppStore } from '../../../store';
import type { AvatarComposition } from '../types/types';

interface KonvaStage {
  toDataURL(config?: {
    mimeType?: string;
    quality?: number;
    pixelRatio?: number;
  }): string;
}

interface UseSaveAvatarReturn {
  saveAvatar: (
    avatarComposition: AvatarComposition,
    stage: KonvaStage,
    avatarName?: string
  ) => Promise<void>;
  loadAvatars: () => Promise<void>;
  savedAvatars: UserAvatarSave[];
  isSaving: boolean;
  isLoading: boolean;
  error: string | null;
  lastSavedAvatarId: string | null;
}

export function useSaveAvatar(): UseSaveAvatarReturn {
  const { user, refreshUser } = useAppStore();
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [savedAvatars, setSavedAvatars] = useState<UserAvatarSave[]>([]);
  const [lastSavedAvatarId, setLastSavedAvatarId] = useState<string | null>(null);

  const saveAvatar = async (
    avatarComposition: AvatarComposition,
    stage: KonvaStage,
    avatarName = 'Mi Avatar' 
  ) => {
    setIsSaving(true);
    setError(null);

    try {
            
      const userId = user?._id;
      const result = await saveUserAvatar(avatarComposition, stage, avatarName, userId);
      
      if (result.success) {
                setLastSavedAvatarId(result.avatarId || null);
        
        await loadAvatars();
        
        try {
          await refreshUser();
        } catch (refreshError) {
        }
      } else {
        throw new Error(result.error || 'Error desconocido al guardar avatar');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
            setError(errorMessage);
    } finally {
      setIsSaving(false);
    }
  };

  const loadAvatars = async () => {
    setIsLoading(true);
    setError(null);

    try {
            
      const userId = user?._id;
      const avatars = await loadUserAvatars(userId);
      setSavedAvatars(avatars);
          } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
            setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    saveAvatar,
    loadAvatars,
    savedAvatars,
    isSaving,
    isLoading,
    error,
    lastSavedAvatarId
  };
}
